// Staggered entrance for the light form panel. Fields are visible by default;
// this only adds the motion trigger, so a Freeform AJAX re-render or a missing
// IntersectionObserver never leaves a field hidden. Motion itself is gated in
// CSS behind prefers-reduced-motion: no-preference.
function wireFormReveal(root = document) {
	const panels = root.querySelectorAll(
		'.form-fields--light:not([data-ff-reveal])',
	)
	if (!panels.length) return

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return
				entry.target.classList.add('is-revealing')
				obs.unobserve(entry.target)
			})
		},
		{ rootMargin: '0px 0px -12% 0px' },
	)

	panels.forEach((panel) => {
		panel.dataset.ffReveal = ''
		observer.observe(panel)
	})
}

if (document.readyState !== 'loading') {
	wireFormReveal()
} else {
	document.addEventListener('DOMContentLoaded', () => wireFormReveal())
}
